
import React, { useState, useEffect, forwardRef, useCallback } from 'react';
import Box from '@mui/material/Box';
import { useTranslation, Trans } from 'react-i18next'; // Importiere useTranslation-Hook
// makeStyles removed - using sx props
import { Collapse, Button, Divider, Tooltip, List, ListItem, ListItemText, Link, Card, CardActions, Typography, IconButton, Paper, LinearProgress } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import HorizontalSplitRoundedIcon from '@mui/icons-material/HorizontalSplitRounded';
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { SnackbarContent, useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { bulkTranslationGetTasks } from '../modules/bulkTranslation';
import { parseItemId } from '../helper';
import { alertSurface } from '../theme';

const snackStyles = {
  link: {
    cursor: 'pointer',
    color: 'inherit',
    textDecoration: 'underline',
  },
  actionRoot: {
    paddingLeft: 2,
  },
  typography: {
    flex: 1,
    color: 'inherit',
  },
  btn: {
    marginLeft: 1,
  },
  list: {
    marginLeft: '0 !important',
  },
};

export const SaveInfosList = React.forwardRef(({id, ...props}, ref) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState(true);
  const [copied, setCopied] = useState(false);

  const handleExpandClick = useCallback(() => {
    setExpanded((oldExpanded) => !oldExpanded);
  }, []);

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);


  const handleClick = (itemId, fieldId, subfieldsId) => {
    props.history.push(`/${props.scope}/${itemId}#${subfieldsId ? subfieldsId + ':' + fieldId : fieldId}`);
  };

  const handleOpenTemplate = (url) => {
    window.open(url, '_blank');
  }

  const handleCopyToClipboard = (text) => {
    var textToCopy = text;
    var textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();

    document.execCommand('copy');
    document.body.removeChild(textArea);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }
  
  return <SnackbarContent ref={ref} className="error-list-snackbar">
    <Card sx={(theme) => alertSurface(theme, 'error', { opacity: 0.32 })}>
      <CardActions sx={snackStyles.actionRoot}>
        <Typography variant="body2" sx={snackStyles.typography}>
          <ErrorOutlineOutlinedIcon style={{marginRight: 12}} />
          <Trans i18nKey={'saveInfos.itemCount'} count={props.infos.length}></Trans>
        </Typography>
        <Box sx={snackStyles.icons}>
          <IconButton
            aria-label="Show more"
            size="small"
            onClick={handleExpandClick}
          >
            <ExpandMoreIcon />
          </IconButton>
          <IconButton
            size="small"
            sx={snackStyles.expand}
            onClick={handleDismiss}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Paper sx={snackStyles.paper}>
          <List dense>
            {props.infos.map((item) => (
              <ListItem key={`info-list-${item.object}`}>
                <ListItemText
                sx={snackStyles.list}
                  disableTypography
                  primary={<span>
                      {props.rawData.find(x => x.id === parseItemId(item.object)) && props.rawData.find(x => x.id === parseItemId(item.object)).title}
                      <Tooltip title={t('system.copyToClipboard')} arrow>
                        <Button onClick={() => {handleCopyToClipboard(item.info.asset_value_published)}} size="small" variant="outlined" sx={snackStyles.btn}>
                          <FileCopyOutlinedIcon style={{marginRight: 8, fontSize: 16}} />{copied ? t('system.copied') : t('system.copy')}
                        </Button>
                      </Tooltip>
                      <Tooltip title={t('saveInfos.openTemplateInShopify')} arrow>
                        <Button onClick={() => {handleOpenTemplate(item.info.full_asset_url)}} size="small" variant="outlined" sx={snackStyles.btn}>
                          <OpenInNewOutlinedIcon style={{marginRight: 8, fontSize: 16}} />{t('system.open')}
                        </Button>
                      </Tooltip>
                    </span>
                  }
                  //secondary={}
                />
              </ListItem>
            )
          )}
          </List>
        </Paper>
      </Collapse>
    </Card>
  </SnackbarContent>
})

export const SaveErrorsList = React.forwardRef(({id, ...props}, ref) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = useCallback(() => {
    setExpanded((oldExpanded) => !oldExpanded);
  }, []);

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);


  useEffect(() => {
    //console.log(props.errors)
  }, [props.errors])

  const handleClick = (itemId, fieldId, subfieldsId) => {
    props.history.push(`/${props.scope}/${itemId}#${subfieldsId ? subfieldsId + ':' + fieldId : fieldId}`);
  };
  
  return <SnackbarContent ref={ref} className="error-list-snackbar">
    <Card sx={(theme) => alertSurface(theme, 'error', { opacity: 0.32 })}>
      <CardActions sx={snackStyles.actionRoot}>
        <Typography variant="body2" sx={snackStyles.typography}>
          <ErrorOutlineOutlinedIcon style={{marginRight: 12}} />
          <Trans i18nKey={'saveErrors.errorCount'} count={props.errors.reduce((sum, row) => sum + row.errors.length, 0)}></Trans>
          <Trans i18nKey={'saveErrors.itemCount'} count={props.errors.length}></Trans>
        </Typography>
        <Box sx={snackStyles.icons}>
          <IconButton
            aria-label="Show more"
            size="small"
            onClick={handleExpandClick}
          >
            <ExpandMoreIcon />
          </IconButton>
          <IconButton
            size="small"
            sx={snackStyles.expand}
            onClick={handleDismiss}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Paper sx={snackStyles.paper}>
          <List dense>
            {props.errors.map((item) => (
              <ListItem key={`error-list-${item.object}`} 
                //component={Link} 
                //to={'/metaobjects/1844412506'}
                //href={`/${props.scope}/${item.itemId}`}
                //onClick={() => { handleClick(item.itemId)}}
              >

                  <ListItemText
                    disableTypography
                    primary={<span onClick={() => { handleClick(parseItemId(item.object), '')}}>
                        {props.rawData.find(x => x.id === parseItemId(item.object)) && props.rawData.find(x => x.id === parseItemId(item.object)).title}{' > '}
                      </span>
                    }
                    secondary={<ul>
                      {item.errors && Array.isArray(item.errors) && item.errors.map((error, i) => 
                        <li key={`snackbar-error-list-item-${i}`} onClick={() => { handleClick(parseItemId(item.object), error.object_key, error.object_subfieldsId)}} style={{cursor: 'pointer'}}>
                          {error.object_subfieldsId && `${error.object_subfieldsId} > `}
                          {`${error.object_key} > `}
                          {t(`saveErrors.errorTypes.${Object.entries(error.validation_errors)[0][0]}`,{ type: error.object_type })}
                          <Tooltip title={Object.entries(error.validation_errors)[0][1]}>
                            <InfoOutlinedIcon style={{ fontSize: 18, marginLeft: 4 }} />
                          </Tooltip>
                        </li>
                      )}
                    </ul>}
                  />

              </ListItem>
            )
          )}
          </List>
        </Paper>
      </Collapse>
    </Card>
  </SnackbarContent>
})
export const BulkTranslationStatusSnackbar = React.forwardRef(({ id, onGoToBulk }, ref) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const bulkTranslation = useSelector((state) => state.bulkTranslation);

  // Fetch running tasks on mount so Redux state is up-to-date on non-bulk pages
  React.useEffect(() => {
    dispatch(bulkTranslationGetTasks(() => {}));
  }, [dispatch]);

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  const isTranslating = bulkTranslation.translate_words_pending;
  const isCounting = bulkTranslation.count_words_pending;
  const hasTasks = Object.keys(bulkTranslation.tasks || {}).length > 0;
  const totalWords = bulkTranslation.total_words || 0;
  const progress = isTranslating ? bulkTranslation.translate_progress : bulkTranslation.count_progress;

  const [justCompleted, setJustCompleted] = React.useState(false);
  const prevTranslateWordsPendingRef = React.useRef(isTranslating);
  React.useEffect(() => {
    if (prevTranslateWordsPendingRef.current && !isTranslating) {
      setJustCompleted(true);
    }
    if (isTranslating) {
      setJustCompleted(false);
    }
    prevTranslateWordsPendingRef.current = isTranslating;
  }, [isTranslating]);

  const label = t('bulkTranslationFeature.statusDialog.title');

  let status;
  if (justCompleted) {
    status = t('bulkTranslationFeature.settingsDialog.step4.translationCompleted', 'Your translation has been completed successfully!');
  } else if (isTranslating) {
    status = t('bulkTranslationFeature.statusDialog.processRunning', { translateProgress: progress });
  } else if (isCounting) {
    status = t('bulkTranslationFeature.settingsDialog.step3.countProgressInfo', { countProgress: progress, totalWordCount: totalWords.toLocaleString() });
  } else if (hasTasks && !isTranslating && !isCounting) {
    status = t('bulkTranslationFeature.statusDialog.wordsFound', { totalWords: totalWords.toLocaleString() });
  } else {
    status = t('bulkTranslationFeature.statusDialog.title');
  }

  return (
    <SnackbarContent ref={ref}>
      {/*
        Kein `backgroundColor` mehr: `Card` ist ein `Paper` und liefert
        `background.paper` samt `text.primary` von selbst. Vorher war die Fläche
        auf '#fff' festgenagelt, während die Statuszeile darunter die
        Modus-Textfarbe erbte — im Dark Mode also weiss auf weiss.

        Die Vordergründe müssen dabei mitfallen: Label und Close-Icon waren
        hartcodiert dunkel und wären auf der jetzt dunklen Fläche unlesbar.
        Beide erben ihre Farbe nun von der Card bzw. vom IconButton
        (`action.active`), die beide dem Modus folgen.
      */}
      <Card sx={{ width: 230 }}>
        <CardActions style={{ paddingLeft: 10, paddingRight: 4, paddingTop: 6, paddingBottom: 4 }}>
          <HorizontalSplitRoundedIcon sx={{ color: 'accentSurface.text', marginRight: '6px', fontSize: 16, flexShrink: 0 }} />
          <Typography variant="body2" style={{ flex: 1, lineHeight: 1.3 }}>
            {label}
          </Typography>
          <IconButton size="small" onClick={handleDismiss} style={{ padding: 2 }}>
            <CloseIcon style={{ fontSize: 14 }} />
          </IconButton>
        </CardActions>
        <LinearProgress
          variant="determinate"
          value={progress || 0}
          style={{ margin: '0 0 2px 0' }}
        />
        <div style={{ paddingLeft: 10, paddingBottom: 6 }}>
          <Typography variant="caption" >
            {status}
          </Typography>
          <br />
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={onGoToBulk}
          >
            {t('bulkTranslationFeature.statusDialog.goToBulk', 'Go to Bulk Translation')}
          </Button>
        </div>
      </Card>
    </SnackbarContent>
  );
})

const LS_BULK_KEY = 'ly-current-bulk';
const LS_BULK_EVENT = 'ly-current-bulk-changed';

export function setCurrentBulkTask(tasksObject) {
  localStorage.setItem(LS_BULK_KEY, JSON.stringify(tasksObject));
  window.dispatchEvent(new Event(LS_BULK_EVENT));
}

export function clearCurrentBulkTask() {
  localStorage.removeItem(LS_BULK_KEY);
  window.dispatchEvent(new Event(LS_BULK_EVENT));
}

export function BulkTranslationSnackbarManager() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const location = useLocation();
  const history = useHistory();
  const allTasks = useSelector((state) => state.bulkTranslation.tasks);
  const snackbarKeyRef = React.useRef(null);

  const [hasCurrentBulk, setHasCurrentBulk] = React.useState(!!localStorage.getItem(LS_BULK_KEY));
  const isOnBulkPage = location.pathname === '/machinetranslation/bulk';

  // Keep hasCurrentBulk in sync with localStorage via custom event
  useEffect(() => {
    const handler = () => setHasCurrentBulk(!!localStorage.getItem(LS_BULK_KEY));
    window.addEventListener(LS_BULK_EVENT, handler);
    return () => window.removeEventListener(LS_BULK_EVENT, handler);
  }, []);

  // Save full tasks object to localStorage whenever tasks meaningfully change
  const allTasksJSON = React.useMemo(
    () => (allTasks && Object.keys(allTasks).length > 0 ? JSON.stringify(allTasks) : null),
    [allTasks]
  );
  useEffect(() => {
    if (allTasksJSON) setCurrentBulkTask(JSON.parse(allTasksJSON));
  }, [allTasksJSON]);

  useEffect(() => {
    if (hasCurrentBulk && !isOnBulkPage) {
      if (!snackbarKeyRef.current) {
        snackbarKeyRef.current = enqueueSnackbar('', {
          persist: true,
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          content: (key) => <BulkTranslationStatusSnackbar id={key} onGoToBulk={() => history.push('/machinetranslation/bulk')} />,
        });
      }
    }
    if (isOnBulkPage && snackbarKeyRef.current) {
      closeSnackbar(snackbarKeyRef.current);
      snackbarKeyRef.current = null;
    }
    if (!hasCurrentBulk && snackbarKeyRef.current) {
      closeSnackbar(snackbarKeyRef.current);
      snackbarKeyRef.current = null;
    }
  }, [hasCurrentBulk, isOnBulkPage]);

  return null;
}
